import { render } from "./ParametersCard.vue?vue&type=template&id=2978d0ea&scoped=true"
import script from "./ParametersCard.vue?vue&type=script&lang=js"
export * from "./ParametersCard.vue?vue&type=script&lang=js"

import "./ParametersCard.vue?vue&type=style&index=0&id=2978d0ea&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2978d0ea"]])

export default __exports__